module.exports = __webpack_public_path__ + "media/theme/icons-06782720.ttf";